import PropTypes from 'prop-types'

import TrackedExternalLink from 'components/common/TrackedExternalLink'
import theme from 'theme'

const AcceptPrivacyPolicy = ({ onChange, privacyPolicyAccepted }) => {
  return (
    <label
      css={{
        width: '100%',
        display: 'flex',
        textAlign: 'left',
        alignItems: 'center',
        marginBottom: theme.space[3]
      }}
    >
      <input
        checked={privacyPolicyAccepted}
        css={{
          marginRight: theme.space[3]
        }}
        name="accept-privacy-policy"
        type="checkbox"
        onChange={onChange}
      />
      <span>
        I have read &amp; accept the&nbsp;
        <TrackedExternalLink href="https://www.gremlin.com/privacy/">
          Gremlin, Inc. Privacy Policy
        </TrackedExternalLink>
        , and agree to allow my data to be stored in the US.
      </span>
    </label>
  )
}

AcceptPrivacyPolicy.propTypes = {
  onChange: PropTypes.func,
  privacyPolicyAccepted: PropTypes.bool
}

export default AcceptPrivacyPolicy
